/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class CodeRuleServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 详情
     * @param id (optional) id
     * @return OK
     */
    detail(id: string | null | undefined): Promise<CodeRuleDetailVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.39/masterlink-cps-code-generator')+ "/code-rule/detail?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<CodeRuleDetailVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? CodeRuleDetailVO.fromJS(resultData200) : new CodeRuleDetailVO();
            return result200;
        }
        return Promise.resolve<CodeRuleDetailVO>(<any>null);
    }

    /**
     * 根据应用编码查询规则
     * @param applicationCode (optional) applicationCode
     * @return OK
     */
    list(applicationCode: string | null | undefined): Promise<CodeRuleVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.39/masterlink-cps-code-generator')+ "/code-rule/list?";
        if (applicationCode !== undefined)
            url_ += "applicationCode=" + encodeURIComponent("" + applicationCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<CodeRuleVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CodeRuleVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<CodeRuleVO[]>(<any>null);
    }

    /**
     * 分页
     * @param codeRule codeRule
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    page(codeRule: CodeRuleSearchDTO, current: number | null | undefined, size: number | null | undefined): Promise<IPageOfCodeRuleVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.39/masterlink-cps-code-generator')+ "/code-rule/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(codeRule);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<IPageOfCodeRuleVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfCodeRuleVO.fromJS(resultData200) : new IPageOfCodeRuleVO();
            return result200;
        }
        return Promise.resolve<IPageOfCodeRuleVO>(<any>null);
    }

    /**
     * 归档编码规则
     * @param ids 主键集合
     * @return OK
     */
    remove(ids: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.39/masterlink-cps-code-generator')+ "/code-rule/remove?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 新增
     * @param codeRule codeRule
     * @return OK
     */
    save(codeRule: CodeRuleSaveDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.39/masterlink-cps-code-generator')+ "/code-rule/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(codeRule);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class CodeGeneratorServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取所有应用对象编码以及名称
     * @return OK
     */
    getAllApplicationObjects(): Promise<ApplicationObjectDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.39/masterlink-cps-code-generator')+ "/code/application-objects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllApplicationObjects(_response);
        });
    }

    protected processGetAllApplicationObjects(response: AxiosResponse): Promise<ApplicationObjectDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationObjectDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ApplicationObjectDTO[]>(<any>null);
    }

    /**
     * 根据应用对象获取表单字段
     * @param applicationObjectCode (optional) applicationObjectCode
     * @return OK
     */
    getFormFields(applicationObjectCode: string | null | undefined): Promise<FormFieldsDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.39/masterlink-cps-code-generator')+ "/code/form-fields?";
        if (applicationObjectCode !== undefined)
            url_ += "applicationObjectCode=" + encodeURIComponent("" + applicationObjectCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetFormFields(_response);
        });
    }

    protected processGetFormFields(response: AxiosResponse): Promise<FormFieldsDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormFieldsDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<FormFieldsDTO[]>(<any>null);
    }
}

export class FieldMappingServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 分页
     * @param current (optional) 当前页
     * @param fieldMappingSearchDTO fieldMappingSearchDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    page(current: number | null | undefined, fieldMappingSearchDTO: FieldMappingSearchDTO, size: number | null | undefined): Promise<IPageOfFieldMappingVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.39/masterlink-cps-code-generator')+ "/field-mapping/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fieldMappingSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<IPageOfFieldMappingVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfFieldMappingVO.fromJS(resultData200) : new IPageOfFieldMappingVO();
            return result200;
        }
        return Promise.resolve<IPageOfFieldMappingVO>(<any>null);
    }

    /**
     * 逻辑删除
     * @param ids 主键集合
     * @return OK
     */
    remove(ids: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.39/masterlink-cps-code-generator')+ "/field-mapping/remove?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 新增或更新
     * @param fieldMappingDTO fieldMappingDTO
     * @return OK
     */
    save(fieldMappingDTO: FieldMappingDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.39/masterlink-cps-code-generator')+ "/field-mapping/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fieldMappingDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class ApplicationObjectDTO implements IApplicationObjectDTO {
    /** 应用对象 */
    applicationObject!: string | undefined;
    /** 应用对象编码 */
    applicationObjectCode!: string | undefined;

    constructor(data?: IApplicationObjectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applicationObject = data["applicationObject"];
            this.applicationObjectCode = data["applicationObjectCode"];
        }
    }

    static fromJS(data: any): ApplicationObjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationObjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationObject"] = this.applicationObject;
        data["applicationObjectCode"] = this.applicationObjectCode;
        return data; 
    }
}

export interface IApplicationObjectDTO {
    /** 应用对象 */
    applicationObject: string | undefined;
    /** 应用对象编码 */
    applicationObjectCode: string | undefined;
}

/** 编码规则 */
export class CodeRuleDetailVO implements ICodeRuleDetailVO {
    /** 应用对象 */
    applicationObject!: string | undefined;
    /** 应用对象编码 */
    applicationObjectCode!: string | undefined;
    /** 编码预览 */
    codePreview!: string[] | undefined;
    /** 应用对象字段列表 */
    fieldList!: CodeRuleFieldDTO[] | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 规则名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: ICodeRuleDetailVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applicationObject = data["applicationObject"];
            this.applicationObjectCode = data["applicationObjectCode"];
            if (data["codePreview"] && data["codePreview"].constructor === Array) {
                this.codePreview = [] as any;
                for (let item of data["codePreview"])
                    this.codePreview!.push(item);
            }
            if (data["fieldList"] && data["fieldList"].constructor === Array) {
                this.fieldList = [] as any;
                for (let item of data["fieldList"])
                    this.fieldList!.push(CodeRuleFieldDTO.fromJS(item));
            }
            this.id = data["id"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): CodeRuleDetailVO {
        data = typeof data === 'object' ? data : {};
        let result = new CodeRuleDetailVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationObject"] = this.applicationObject;
        data["applicationObjectCode"] = this.applicationObjectCode;
        if (this.codePreview && this.codePreview.constructor === Array) {
            data["codePreview"] = [];
            for (let item of this.codePreview)
                data["codePreview"].push(item);
        }
        if (this.fieldList && this.fieldList.constructor === Array) {
            data["fieldList"] = [];
            for (let item of this.fieldList)
                data["fieldList"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

/** 编码规则 */
export interface ICodeRuleDetailVO {
    /** 应用对象 */
    applicationObject: string | undefined;
    /** 应用对象编码 */
    applicationObjectCode: string | undefined;
    /** 编码预览 */
    codePreview: string[] | undefined;
    /** 应用对象字段列表 */
    fieldList: CodeRuleFieldDTO[] | undefined;
    /** 主键 */
    id: string | undefined;
    /** 规则名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class CodeRuleFieldDTO implements ICodeRuleFieldDTO {
    /** 业务Id */
    bizDataId!: string | undefined;
    /** 编码规则主键 */
    codeRuleId!: string | undefined;
    /** 补位符/日期分隔符/时间分隔符 */
    complementBit!: number | undefined;
    /** 文本内容 */
    content!: string | undefined;
    /** 内容类型 */
    contentType!: number | undefined;
    /** 日期格式 */
    dateFormat!: number | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 长度 */
    length!: number | undefined;
    /** 最大值 */
    maxLength!: number | undefined;
    /** 最小值 */
    minLength!: number | undefined;
    /** 字段名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 排序 */
    sort!: number | undefined;
    /** 起始位 */
    startBit!: number | undefined;
    /** 步长 */
    step!: number | undefined;
    /** 时间格式 */
    timeFormat!: number | undefined;
    /** 字段类型/文本/日期/时间/流水号 */
    type!: number | undefined;
    /** 更新周期：1：每天 2：每周 3：每月 4：达到上限 */
    updateCycle!: number | undefined;
    /** 是否补0(0:不补,1:补) */
    zeroComplement!: number | undefined;

    constructor(data?: ICodeRuleFieldDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bizDataId = data["bizDataId"];
            this.codeRuleId = data["codeRuleId"];
            this.complementBit = data["complementBit"];
            this.content = data["content"];
            this.contentType = data["contentType"];
            this.dateFormat = data["dateFormat"];
            this.id = data["id"];
            this.length = data["length"];
            this.maxLength = data["maxLength"];
            this.minLength = data["minLength"];
            this.name = data["name"];
            this.remark = data["remark"];
            this.sort = data["sort"];
            this.startBit = data["startBit"];
            this.step = data["step"];
            this.timeFormat = data["timeFormat"];
            this.type = data["type"];
            this.updateCycle = data["updateCycle"];
            this.zeroComplement = data["zeroComplement"];
        }
    }

    static fromJS(data: any): CodeRuleFieldDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CodeRuleFieldDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bizDataId"] = this.bizDataId;
        data["codeRuleId"] = this.codeRuleId;
        data["complementBit"] = this.complementBit;
        data["content"] = this.content;
        data["contentType"] = this.contentType;
        data["dateFormat"] = this.dateFormat;
        data["id"] = this.id;
        data["length"] = this.length;
        data["maxLength"] = this.maxLength;
        data["minLength"] = this.minLength;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["sort"] = this.sort;
        data["startBit"] = this.startBit;
        data["step"] = this.step;
        data["timeFormat"] = this.timeFormat;
        data["type"] = this.type;
        data["updateCycle"] = this.updateCycle;
        data["zeroComplement"] = this.zeroComplement;
        return data; 
    }
}

export interface ICodeRuleFieldDTO {
    /** 业务Id */
    bizDataId: string | undefined;
    /** 编码规则主键 */
    codeRuleId: string | undefined;
    /** 补位符/日期分隔符/时间分隔符 */
    complementBit: number | undefined;
    /** 文本内容 */
    content: string | undefined;
    /** 内容类型 */
    contentType: number | undefined;
    /** 日期格式 */
    dateFormat: number | undefined;
    /** 主键 */
    id: string | undefined;
    /** 长度 */
    length: number | undefined;
    /** 最大值 */
    maxLength: number | undefined;
    /** 最小值 */
    minLength: number | undefined;
    /** 字段名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 排序 */
    sort: number | undefined;
    /** 起始位 */
    startBit: number | undefined;
    /** 步长 */
    step: number | undefined;
    /** 时间格式 */
    timeFormat: number | undefined;
    /** 字段类型/文本/日期/时间/流水号 */
    type: number | undefined;
    /** 更新周期：1：每天 2：每周 3：每月 4：达到上限 */
    updateCycle: number | undefined;
    /** 是否补0(0:不补,1:补) */
    zeroComplement: number | undefined;
}

export class CodeRuleSaveDTO implements ICodeRuleSaveDTO {
    /** 应用对象 */
    applicationObject!: string | undefined;
    /** 应用对象编码 */
    applicationObjectCode!: string | undefined;
    /** 应用对象字段列表 */
    fieldList!: CodeRuleFieldDTO[] | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 规则名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: ICodeRuleSaveDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applicationObject = data["applicationObject"];
            this.applicationObjectCode = data["applicationObjectCode"];
            if (data["fieldList"] && data["fieldList"].constructor === Array) {
                this.fieldList = [] as any;
                for (let item of data["fieldList"])
                    this.fieldList!.push(CodeRuleFieldDTO.fromJS(item));
            }
            this.id = data["id"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): CodeRuleSaveDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CodeRuleSaveDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationObject"] = this.applicationObject;
        data["applicationObjectCode"] = this.applicationObjectCode;
        if (this.fieldList && this.fieldList.constructor === Array) {
            data["fieldList"] = [];
            for (let item of this.fieldList)
                data["fieldList"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface ICodeRuleSaveDTO {
    /** 应用对象 */
    applicationObject: string | undefined;
    /** 应用对象编码 */
    applicationObjectCode: string | undefined;
    /** 应用对象字段列表 */
    fieldList: CodeRuleFieldDTO[] | undefined;
    /** 主键 */
    id: string | undefined;
    /** 规则名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class CodeRuleSearchDTO implements ICodeRuleSearchDTO {
    /** 是否高级筛选 */
    filterPlus!: boolean | undefined;
    /** 关键字查询 */
    keyWords!: string | undefined;
    /** 查询条件字典 */
    param!: any | undefined;

    constructor(data?: ICodeRuleSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filterPlus = data["filterPlus"];
            this.keyWords = data["keyWords"];
            this.param = data["param"];
        }
    }

    static fromJS(data: any): CodeRuleSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CodeRuleSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterPlus"] = this.filterPlus;
        data["keyWords"] = this.keyWords;
        data["param"] = this.param;
        return data; 
    }
}

export interface ICodeRuleSearchDTO {
    /** 是否高级筛选 */
    filterPlus: boolean | undefined;
    /** 关键字查询 */
    keyWords: string | undefined;
    /** 查询条件字典 */
    param: any | undefined;
}

/** 编码规则 */
export class CodeRuleVO implements ICodeRuleVO {
    /** 应用对象 */
    applicationObject!: string | undefined;
    /** 应用对象编码 */
    applicationObjectCode!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 规则名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: ICodeRuleVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applicationObject = data["applicationObject"];
            this.applicationObjectCode = data["applicationObjectCode"];
            this.id = data["id"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): CodeRuleVO {
        data = typeof data === 'object' ? data : {};
        let result = new CodeRuleVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationObject"] = this.applicationObject;
        data["applicationObjectCode"] = this.applicationObjectCode;
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

/** 编码规则 */
export interface ICodeRuleVO {
    /** 应用对象 */
    applicationObject: string | undefined;
    /** 应用对象编码 */
    applicationObjectCode: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 规则名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

/** 字段映射实体 */
export class FieldMappingDTO implements IFieldMappingDTO {
    /** 映射编码 */
    code!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 映射名称 */
    name!: string | undefined;

    constructor(data?: IFieldMappingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): FieldMappingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FieldMappingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

/** 字段映射实体 */
export interface IFieldMappingDTO {
    /** 映射编码 */
    code: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 映射名称 */
    name: string | undefined;
}

/** 字段映射高级搜索 */
export class FieldMappingSearchDTO implements IFieldMappingSearchDTO {
    /** 是否高级筛选 */
    filterPlus!: boolean | undefined;
    /** 关键字查询 */
    keyWords!: string | undefined;
    /** 查询条件字典 */
    param!: any | undefined;

    constructor(data?: IFieldMappingSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filterPlus = data["filterPlus"];
            this.keyWords = data["keyWords"];
            this.param = data["param"];
        }
    }

    static fromJS(data: any): FieldMappingSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FieldMappingSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterPlus"] = this.filterPlus;
        data["keyWords"] = this.keyWords;
        data["param"] = this.param;
        return data; 
    }
}

/** 字段映射高级搜索 */
export interface IFieldMappingSearchDTO {
    /** 是否高级筛选 */
    filterPlus: boolean | undefined;
    /** 关键字查询 */
    keyWords: string | undefined;
    /** 查询条件字典 */
    param: any | undefined;
}

/** 编码字段映射 */
export class FieldMappingVO implements IFieldMappingVO {
    /** 映射编码 */
    code!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 映射名称 */
    name!: string | undefined;

    constructor(data?: IFieldMappingVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): FieldMappingVO {
        data = typeof data === 'object' ? data : {};
        let result = new FieldMappingVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

/** 编码字段映射 */
export interface IFieldMappingVO {
    /** 映射编码 */
    code: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 映射名称 */
    name: string | undefined;
}

export class FormFieldsDTO implements IFormFieldsDTO {
    /** 类型区分 */
    bizDataId!: string | undefined;
    /** 字段code */
    code!: string | undefined;
    /** 字段名称 */
    name!: string | undefined;

    constructor(data?: IFormFieldsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bizDataId = data["bizDataId"];
            this.code = data["code"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): FormFieldsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FormFieldsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bizDataId"] = this.bizDataId;
        data["code"] = this.code;
        data["name"] = this.name;
        return data; 
    }
}

export interface IFormFieldsDTO {
    /** 类型区分 */
    bizDataId: string | undefined;
    /** 字段code */
    code: string | undefined;
    /** 字段名称 */
    name: string | undefined;
}

export class IPageOfCodeRuleVO implements IIPageOfCodeRuleVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: CodeRuleVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfCodeRuleVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(CodeRuleVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfCodeRuleVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfCodeRuleVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfCodeRuleVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: CodeRuleVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfFieldMappingVO implements IIPageOfFieldMappingVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: FieldMappingVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfFieldMappingVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(FieldMappingVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfFieldMappingVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfFieldMappingVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfFieldMappingVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: FieldMappingVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}